import React from "react";
import "./PccHeadContent.css";
const PccHeadContent = () => {
  return (
    <div className="pccHeadContentContainer">
      <h1>
        PCC Verification in Bangalore: Comprehensive Services by{" "}
        <span> Goodway Attestation</span>
      </h1>
      <p>
        Police Clearance Certificate (PCC) verification is a crucial process for
        individuals planning to travel, work, or reside abroad. This document
        certifies that the applicant has no criminal record and is thus cleared
        for various international purposes. Goodway Attestation Services in
        Bangalore provides efficient and reliable PCC verification services,
        ensuring that your certificate is authenticated and accepted by foreign
        authorities.
      </p>
    </div>
  );
};

export default PccHeadContent;
